import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { useView, autoinject, Container, transient, inject } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import moment from 'moment'
import AuditLogSearchCriteria from "../../Scripts/AuditLogSearchCriteria";
import SortBy from "../../../../Lib/Fs.Core.Data/SortBy";
import AuditLogSearchData from "../../Scripts/AppServiceContract/AuditLogSearchData";
import AuditLogSearchAppService from "../../Scripts/AppServiceContract/AuditLogSearchAppService";
import AuditLogSearchParameter from "../../Scripts/AppServiceContract/AuditLogSearchParameter";
import SortingCriteria from "../../../../Lib/Fs.Core.Data/SortingCriteria";
import PagingCriteria from "../../../../Lib/Fs.Core.Data/PagingCriteria";
import SearchVMBase from "../../../../Lib/Fs.SmartClient.Client/SearchVMBase";
import SearchOnlyVMBase from "../../../../Lib/Fs.SmartClient.Client/SearchOnlyVMBase";
import AuditLogCategoryData01 from "../../Scripts/AppServiceContract/AuditLogCategoryData01";
import UserData01 from "../../Scripts/AppServiceContract/UserData01";
import ManageUserAppService from "../../Scripts/AppServiceContract/ManageUserAppService";
import { PLATFORM } from 'aurelia-pal';

@autoinject
@useView(PLATFORM.moduleName("./AuditLogSearchView.html"))
export default class AuditLogSearchVM extends SearchOnlyVMBase<AuditLogSearchData>{
  DateFrom: any;
  DateTo: any;
  SelectedUserId: string;
  AuditLogCategoryCode: string;
  AuditLogSearchData: AuditLogSearchData[];
  SelectedUser: UserData01;
  UserList: UserData01[];
  AuditLogCategoryData01: AuditLogCategoryData01[];

  protected container: Container;
  constructor() {
    super(AuditLogSearchData);
    this.container = Container.instance;
    this.DefaultDate();
    this.Search();
    this.FindAuditLogCategoryDropdown();
    
  }

  DefaultDate() {
    this.DateFrom = moment().format("DD-MM-YYYY");
    this.DateTo = moment().format("DD-MM-YYYY");
  }

  ConvertDate(DDMMYYYY: Date): Date {
    if (!DDMMYYYY) {
      return null;
    }
    var DDMMYYYY_string = DDMMYYYY.toString().replace("/", "-");
    DDMMYYYY_string = DDMMYYYY_string.toString().replace("/", "-");
    var dateParts = DDMMYYYY_string.split("-");

    // month is 0-based, that's why we need dataParts[1] - 1
    var YYYYMMDD = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);

    var javascriptdate = new Date(YYYYMMDD);
    return javascriptdate;
  }

  SearchCriteria: AuditLogSearchCriteria;

  CheckCriteriaEquals(searchCriteria: AuditLogSearchCriteria) {
    if (this.SearchCriteria == null) return false;
    return JSON.stringify(this.SearchCriteria) == JSON.stringify(searchCriteria);
  }

  CountItems(countCallback: (result: number) => void) {
    var self = this;
    var req = self.CreateCriteria();

    if (!this.CheckCriteriaEquals(req)) {
      this.SearchCriteria = req;
      var service = Container.instance.get(AuditLogSearchAppService) as AuditLogSearchAppService;
      service.Count(req)
        .done((result) => {
          countCallback(result)
        }).fail(FsUtility.CommonErrorHandler);
    } else {
      countCallback(this.ItemCount);
    }
  }

  public PrepareDefaultSortingCriteria(sortingCriteria: SortBy[]): void {
    var sortBy = new SortBy();
    sortBy.Direction = 0;
    sortBy.Name = "EventDate";
    sortingCriteria.push(sortBy);
  }

  public SearchItems(searchCallback: (result: AuditLogSearchData[]) => void, sortingCriteria: SortingCriteria, pagingCriteria: PagingCriteria): void {
    var criteria = new AuditLogSearchParameter();
    criteria.Criteria = this.SearchCriteria;
    criteria.SortingCriteria = sortingCriteria;
    criteria.PagingCriteria = pagingCriteria;
    var service = (this.container.get(AuditLogSearchAppService) as AuditLogSearchAppService);
    service.Find(criteria)
      .done((result) => {
        debugger
        searchCallback(result);
      }).fail(FsUtility.CommonErrorHandler);
  }

  CreateCriteria(): AuditLogSearchCriteria {
    var criteria = new AuditLogSearchCriteria();
    criteria.AddedByUserUID = this.SelectedUserId == null ? null : this.SelectedUserId;
    criteria.AuditLogCategoryCode = this.AuditLogCategoryCode == null ? null : this.AuditLogCategoryCode;
    criteria.DateFrom = this.ConvertDate(this.DateFrom);
    criteria.DateTo = this.ConvertDate(this.DateTo);
    return criteria;
  }
  FindAuditLogCategoryDropdown() {
    var self = this;
    var service = (this.container.get(AuditLogSearchAppService) as AuditLogSearchAppService).Init({ ajaxOptions: { async: false } });
    service.FindAuditLogCategoryDropdown()
      .done((result) => {
        self.AuditLogCategoryData01 = result
      }).fail((error) => {
        FsUtility.AlertErrorMessage(error);
      });
  }
  FindUserData(params, success, failure) {
    var self = this;
    var service = Container.instance.get(ManageUserAppService) as ManageUserAppService;

    if (params.data.term != null) {
      //service.FindUserAutoCompleteDataWithoutPermission(params.data.term).done((result) => {
      //    self.UserList = result;
      //    success(result);
      //}).fail((error) => {
      //    FsUtility.CommonErrorHandler(error);
      //    failure(error);
      //});
    }
  }
  Clear(): void {
    this.SelectedUser = null;
    this.DateFrom = null;
    this.DateTo = null;
    this.AuditLogCategoryCode = null;
  }


}
